import React, { useEffect, useState } from 'react'
import Template from './Template'
import Button from './UI/Button'
import Title from './UI/Title'
import Loader from './UI/Loader'
import filters from './Filters'
import T from './UI/T'
import { FiArrowLeft, FiArrowRight, FiCheck, FiChevronLeft, FiChevronRight, FiLoader, FiRefreshCw, FiRepeat, FiSun } from 'react-icons/fi'
import { blobToBase64 } from '../utils'

export default function Review({ template, photo, confirm, retry }) {
  const [svgRef, setSvgRef] = useState()
  const [background, setBackground] = useState()
  const [filter, setFilter] = useState()
  const images = template.event_printing_template_images.map(epti => epti.url)

  useEffect(() => {
    setBackground(images[0])
    setFilter(filters[0])
  }, [])

  return (
    <div className="flex flex-col justify-center items-center w-full lg:max-w-5xl mx-auto p-4 lg:p-6 pb-16 lg:pb-32 h-screen">
      <div className="fixed top-0 left-0 p-4 z-20">
        <Button onClick={retry} Icon={FiArrowLeft} variant="icon" />
      </div>
      <div className="relative lg:w-1/2 lg:max-w-md xl:max-w-xl my-2 lg:my-4 flex justify-center items-center">
        <FiChevronLeft
          onClick={() => setBackground(images[(images.indexOf(background) - 1).mod(images.length)])}
          className={`text-primary bg-secondary rounded-full h-12 w-12 p-2 -ml-4 mr-2 flex-shrink-0 cursor-pointer ${images.indexOf(background) == 0 && 'opacity-0 pointer-events-none'}`} />
        <div className="flex justify-center w-full h-full flex-shrink" style={{ filter: 'drop-shadow(2px 2px 10px rgba(0, 0, 0, .2))' }}>
          <Template config={template.printing_template} photo={photo} filter={filter?.svg} background={background} setRef={ref => setSvgRef(ref)} />
        </div>
        <FiChevronRight
          onClick={() => setBackground(images[(images.indexOf(background) + 1).mod(images.length)])}
          className={`text-primary bg-secondary rounded-full h-12 w-12 p-2 -mr-4 ml-2 flex-shrink-0 cursor-pointer`} />
      </div>
      <div>
      <div className="flex relative z-40">
          {filters.map((f, index) =>
            <div key={f.name} className="text-center mx-2 my-1 cursor-pointer">
              <svg viewBox="0 0 300 300" className="h-10 lg:h-12 xl:h-16 rounded-full border-2 border-primary" onClick={() => setFilter(f)}>
                <filter id={`filter-${index}`} colorInterpolationFilters="sRGB" dangerouslySetInnerHTML={{ __html: f.svg }} />
                <image filter={`url(#filter-${index})`} height="100%" width="100%" preserveAspectRatio="xMidYMid slice" href={photo} />
              </svg>
              <div className="text-xs mt-1 opacity-100 select-none">{f.name}</div>
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-center flex-wrap items-center mt-2">
        {/* <Button Icon={FiSun} className="m-1 lg:m-3" onClick={() => setBackground(images[(images.indexOf(background) + 1).mod(images.length)])}><T>editor.theme</T></Button> */}
        <Button Icon={FiCheck} className="m-1 lg:m-3" onClick={() => confirm(svgRef.current?.outerHTML)}><T>editor.confirm</T></Button>
      </div>
    </div>
  )
}
